export default "__VITE_ASSET__Cd$SV7pY__"